var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"border-2 mt-10",attrs:{"id":"short-view"}},[_c('div',_vm._l((_vm.entity),function(item){return _c('LeftViewExpand',{key:item.id,attrs:{"item":item}})}),1)])}
var staticRenderFns = []

export { render, staticRenderFns }